/*
 * Copyright (C) 2024 S&P Global.
 * All Rights Reserved
 */
import { AppIdentifier } from "@finos/fdc3";
import { SessionStorageKeyTemplates } from "../types/lifecycle";
import { interpolate } from "../internal";

export class AppIdentifierService {
  private _browserGlobalScope: Window & typeof globalThis;

  constructor(browserGlobalScope: Window & typeof globalThis) {
    this._browserGlobalScope = browserGlobalScope;
    // console.log(`AppIdentifierService.constructor (${this._browserGlobalScope.location.origin})`);
  }

  public getAppIdentifier(appId: string): AppIdentifier {
    console.log(`AppIdentifierService.getAppIdentifier (appId: ${appId})`);
    const values: Record<string, any> = {
      windowName: this._getWindowName(),
      appId
    };
    const instanceIdKey = interpolate(SessionStorageKeyTemplates.instanceId, values);
    let instanceId = this._browserGlobalScope.sessionStorage.getItem(instanceIdKey);
    if (!instanceId) {
      instanceId = this._browserGlobalScope.crypto?.randomUUID();
      this._browserGlobalScope.sessionStorage.setItem(instanceIdKey, instanceId);
    }
    return {
      appId,
      instanceId,
    };
  }

  private _getWindowName(): string {
    let windowName = this._browserGlobalScope.name;
    if (!windowName) {
      windowName = `${this._browserGlobalScope.location.host}:${this._browserGlobalScope.crypto?.randomUUID()}`;
      this._browserGlobalScope.name = windowName;
    }
    return windowName;
  }
}
